const DEVICE_ID_KEY = 'device_id'
const SESSION_ID_KEY = 'sessionId'

const getOrCreateDeviceId = () => {
  let id = localStorage.getItem(DEVICE_ID_KEY)
  if (!id) {
    if (window.crypto && window.crypto.randomUUID) {
      id = window.crypto.randomUUID()
    } else {
      id = `${Date.now()}-${Math.random().toString(16).slice(2)}`
    }
    localStorage.setItem(DEVICE_ID_KEY, id)
  }
  return id
}

const getBrowserName = () => {
  const ua = navigator.userAgent || ''
  if (/Edg\//.test(ua)) return 'Edge'
  if (/OPR\//.test(ua)) return 'Opera'
  if (/Chrome\//.test(ua)) return 'Chrome'
  if (/Firefox\//.test(ua)) return 'Firefox'
  if (/Safari\//.test(ua) && !/Chrome\//.test(ua)) return 'Safari'
  return 'Browser'
}

const getOsName = () => {
  const ua = navigator.userAgent || ''
  if (/Windows/i.test(ua)) return 'Windows'
  if (/Android/i.test(ua)) return 'Android'
  if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS'
  if (/Mac OS X|Macintosh/i.test(ua)) return 'Mac'
  if (/Linux/i.test(ua)) return 'Linux'
  return 'Unknown'
}

const getLoginDevicePayload = () => ({
  device_id: getOrCreateDeviceId(),
  device_name: `${getBrowserName()}/${getOsName()}`,
  platform: 'Web',
})

const clearAuthStorage = () => {
  localStorage.removeItem('accessToken')
  localStorage.removeItem('refreshToken')
  localStorage.removeItem(SESSION_ID_KEY)
  localStorage.removeItem('userData')
}

const getSessionId = () => localStorage.getItem(SESSION_ID_KEY)

const setSessionId = sessionId => {
  if (sessionId) {
    localStorage.setItem(SESSION_ID_KEY, sessionId)
  }
}

export {
  DEVICE_ID_KEY,
  SESSION_ID_KEY,
  clearAuthStorage,
  getLoginDevicePayload,
  getSessionId,
  setSessionId,
}
